// @ts-nocheck
import React, { useEffect } from 'react'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Typography } from 'transfix-ui/core'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { EditIcon } from 'transfix-icons'
import { BCA } from './BCA'
import { EditChecklistDialog } from './EditChecklistDialog/EditChecklistDialog'
import { FMCSA } from './Fmcsa'
import { FSMA } from './Fsma'
import LaneAgreements from './LaneAgreements'
import { OperatingAuthority } from './OperatingAuthority'
import PackageFiles from './PackageFiles'
import { SafetyLetter } from './SafetyLetter'
import { W9Form } from './W9Form'

interface IChecklistsProps {
  carrierId?: number
  checklists?: {
    w9FormReviewedBy?: {}
    safetyLetter?: {}
    fmcsaInfoVerifiedBy?: {}
    fsmaInfoReviewedBy?: {}
    brokerCarrierAgreement?: {}
    operatingAuthorityReviewedBy?: {}
  }
  documents?: {
    fileUrl?: string
  }[]
  dialogDocuments?: {
    fileUrl?: string
  }[]
  getChecklists: (...args: any[]) => any
  getUploadedDocs: (...args: any[]) => any
  opsCarrierChecklistErrors?: string[]
  opsCarrierChecklistLoading?: boolean
  error?: string
  loading?: boolean
  showChecklistDialog?: (...args: any[]) => any
  closeChecklistDialog?: (...args: any[]) => any
  checklistDialog?: {
    dialogOpen?: boolean
  }
  editCarrierChecklist: (...args: any[]) => any
  uploadCarrierDocuments?: (...args: any[]) => any
  addDocUpload?: (...args: any[]) => any
  deleteDocUpload?: (...args: any[]) => any
}

export const Checklists: React.FunctionComponent<IChecklistsProps> = React.memo(
  ({
    addDocUpload,
    carrierId,
    checklistDialog,
    checklists,
    closeChecklistDialog,
    deleteDocUpload,
    dialogDocuments,
    documents,
    editCarrierChecklist: saveChecklist,
    error,
    getChecklists,
    getUploadedDocs,
    loading,
    opsCarrierChecklistErrors,
    opsCarrierChecklistLoading,
    showChecklistDialog: showDialog,
    updateError,
    uploadCarrierDocuments: uploadDocument,
  }) => {
    const { getFlag } = useFeatureFlagContext()
    const { enabled: laneAgreementsEnabled } = getFlag('laneAgreements')

    useEffect(() => {
      if (carrierId) {
        getChecklists(carrierId)
      }
    }, [carrierId, getChecklists])

    return (
      <Card>
        <div className='pv4 row ml0'>
          <Typography variant='h3' className='fl mb0 mt2'>
            Documents
          </Typography>
          <div className='fr'>
            <IconButton
              Icon={EditIcon}
              color='tertiary'
              onClick={showDialog}
              data-test='edit-checklist'
              label='Edit'
              size='large'
            />
          </div>
        </div>
        {opsCarrierChecklistLoading && <Spinner />}
        {opsCarrierChecklistErrors && (
          <FeedbackMessage message={opsCarrierChecklistErrors} type='error' />
        )}
        {checklists && !opsCarrierChecklistErrors && (
          <div>
            <div className='pv4'>
              <BCA
                brokerCarrierAgreement={checklists.brokerCarrierAgreement}
                hideBrokerCarrierAgreement={checklists.hideBrokerCarrierAgreement}
              />
            </div>
            <W9Form w9Form={checklists.w9FormReviewedBy} />
            <OperatingAuthority operatingAuthority={checklists.operatingAuthorityReviewedBy} />
            <FMCSA fmcsa={checklists.fmcsaInfoVerifiedBy} />
            <FSMA fsma={checklists.fsmaInfoReviewedBy} />
            <SafetyLetter
              safetyLetter={checklists.safetyLetterReviewedBy}
              notApplicableSafetyLetter={checklists.safetyLetterNotApplicableReviewedBy}
            />
            <EditChecklistDialog
              carrierId={carrierId}
              dialogOpen={checklistDialog.dialogOpen}
              closeDialog={closeChecklistDialog}
              checklists={checklists}
              saveChecklist={saveChecklist}
              getUploadedDocs={getUploadedDocs}
              documents={documents}
              error={error}
              loading={loading}
              uploadDocument={uploadDocument}
              addDocUpload={addDocUpload}
              deleteDocUpload={deleteDocUpload}
              dialogDocuments={dialogDocuments}
              updateError={updateError}
            />
          </div>
        )}
        <PackageFiles
          carrierId={carrierId}
          getUploadedDocs={getUploadedDocs}
          documents={documents}
          loading={loading}
          error={error}
        />

        {laneAgreementsEnabled && <LaneAgreements carrierApplicationId={carrierId} />}
      </Card>
    )
  }
)
